import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Paper from "@material-ui/core/Paper"
import clsx from "clsx"
import { default as NewGroupModal } from "../Modal/newGroupModal"
import GroupTable from "../Groups/groupTable"
import HomePageWrapper from "../Common/PageWrappers/HomePageWrapper"
import { useLazyLoadSelector } from "../../util/redux"
import { fetchGroups } from "../../actions/groupActions"
import { useSelector } from "react-redux"
import { fetchDevice } from "../../actions/deviceActions"

const styles = (theme) => ({
  devicesCard: {
    width: "20vw",
  },
  toolbar: theme.mixins.toolbar,
  root: {},
  details: {
    display: "flex",
  },
  cardColor: {
    background: "linear-gradient(60deg, #0093C5, #1195C9)",
    color: "white",
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },
  locationText: {
    paddingLeft: "15px",
  },
  buttonProperty: {
    position: "absolute",
    top: "50%",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progess: {
    position: "absolute",
  },
  uploadButton: {
    marginLeft: "8px",
    margin: theme.spacing(1),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  submitButton: {
    marginTop: "10px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableContainers: {
    gap: "2em",
    flexWrap: "wrap-reverse",
  },
  button: {
    "&:focus": {
      color: "white",
      backgroundColor: "#0A94C7",
    },
    "&:hover": {
      color: "white",
      backgroundColor: "#0A94C7",
    },
  },
})

const Groups = (props) => {
  const { classes, ...rest } = props

  useLazyLoadSelector((state) => state.group.groupData, fetchGroups, [], false)
  useLazyLoadSelector((state) => state.device.deviceData, fetchDevice, [], false)
  const loading = useSelector((state) => state.group.loadingGroups || false)

  return (
    <HomePageWrapper loading={loading}>
      <div>
        {/* HEADER FOR GROUPS */}
        <div className={[classes.contentPadding, classes.sectionHeader].join(" ")}>
          <h1>Groups</h1>
          {/* The button for Opening the New Group Modal */}
          <NewGroupModal />
        </div>
        <br />

        {/* GROUPS TABLE */}
        <Paper className={classes.contentPadding}>
          <GroupTable {...rest} className={clsx(classes.root, classes)} tableHeaderColor="info" />
        </Paper>
      </div>
    </HomePageWrapper>
  )
}

export default withStyles(styles)(Groups)
